'use client';

import { Text } from '@chakra-ui/react';
import { FaPrint } from 'react-icons/fa6';

import { ButtonAsLink } from '@ui/button-as-link';

export default function PrintLink() {
  return (
    <ButtonAsLink as="button" onClick={() => window.print()}>
      <FaPrint />
      <Text color="fg">Imprimer</Text>
    </ButtonAsLink>
  );
}
